import styled from 'styled-components';

export const QuickMenuAnchor = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
`;
